// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"523":"d63f83bbc2c608fc","22269":"589d8a59a4be3154","84366":"e3ca36435cb7915e"}[chunkId] + ".css";
};